import baustein from "baustein";
import Overlay from "web/script/utils/overlay";
import template from "templates/settings/delete-payment-confirm.html";

export default baustein.register("payment-item", {
    setupEvents: function(add) {
        add("submit", this._onDelete);
    },

    _onDelete: function(event) {
        event.preventDefault();

        new Overlay({
            content: template(),
            cssClasses: "size-s",
            onRenderFinish: this._onDeleteConfirmOverlayRendered.bind(this),
        });
    },

    _onDeleteConfirmOverlayRendered: function(overlay) {
        var component = overlay.overlayComponent;

        component.registerEvent(
            "click",
            ".delete-payment-confirm__button",
            this._confirmDelete.bind(this)
        );
    },

    _confirmDelete: function() {
        this.el.querySelector("form").submit();
    },
});
